import React, { useState, useEffect } from 'react';
import Swiper from 'swiper';
import { Container, Row, Col } from 'reactstrap';

import c from '../../config';

import { parseSanitizedHTML } from '../../utils/Helper';

// Assets
// import '../../assets/css/swiper.min.css';

const ArticleSlider = ({ lists, title, locale, t }) => {
  const [sliderInit, setSliderInit] = useState(false);
  const toggleSliderInit = () => setSliderInit(!sliderInit);

  // TODO: add pause the slider
  const [mousePause, setMousePause] = useState(false);
  const toggleMousePause = () => setMousePause(!mousePause);

  useEffect(() => {
    if (!sliderInit) {
      initSwiper();
      toggleSliderInit();
    }
  }, [sliderInit]);

  useEffect(() => {
    const sliderContainer = document.getElementById('widget-slider');
    if (mousePause) {
      sliderContainer.swiper.autoplay.stop();
    } else {
      sliderContainer.swiper.autoplay.start();
    }
  }, [mousePause]);

  const initSwiper = () => {
    const mainBanner = document.getElementById('widget-slider');
    if (mainBanner && mainBanner.swiper) {
      mainBanner.swiper.destroy(false, false);
    }
    const autoplayTime = 5000;
    const swiper = new Swiper(mainBanner, {
      spaceBetween: 60,
      slidesPerView: 3,
      slidesPerGroup: 3,
      loop: true,
      loopFillGroupWithBlank: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      simulateTouch: true,
      autoplay: {
        delay: autoplayTime,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        1: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        1025: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      },
      // Disable preloading of all images
      preloadImages: false,
      // Enable lazy loading
      lazy: {
        preloaderClass: 'ss',
      },
    });
  };

  const slide = (list = []) => {
    return list.map((v, k) => {
      const { content = {} } = v;
      return (
        <div className="swiper-slide" key={k}>
          <div className="swiper-slide__content">
            <img src={content[locale].thumbnail} alt={content[locale].alt} />
            <h5>{content[locale].headline}</h5>
            <p>
              {parseSanitizedHTML(content[locale].abstract, c.sliderTruncateLength[locale])}
              <a href={content[locale].link} target="_blank" rel="noopener noreferrer">
                {t.label_btn_details}
              </a>
            </p>
          </div>
        </div>
      );
    });
  };

  return (
    <section className="section-mainPage-slider">
      <Container className="widget-slider slider-container">
        <Row>
          <Col>
            <h3>{title}</h3>
          </Col>
        </Row>
        <div className="swiper-container" id="widget-slider">
          <div className="swiper-wrapper">{slide(lists)}</div>
          <div className="swiper-pagination" />
          <div className="swiper-button-next" />
          <div className="swiper-button-prev" />
          <div
            role="button"
            tabIndex="0"
            className={
              mousePause
                ? 'widget-slider-container__slider-pause is-active'
                : 'widget-slider-container__slider-pause'
            }
            onClick={() => toggleMousePause()}
            onKeyPress={() => toggleMousePause()}
          >
            <div className="pause-button" />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ArticleSlider;
